import { render, staticRenderFns } from "./FeeReductionRewardEditor.vue?vue&type=template&id=7e8a38ee&scoped=true"
import script from "./FeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./FeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a38ee",
  null
  
)

export default component.exports